import { gql, useQuery } from '@apollo/client';
import { Query, QueryFolderArgs } from 'middleware-types';
import { useDocumentsContext } from '../documents-page';
import { getRootFolderName } from '../utils/enum-helpers';

const GET_FOLDER_NAME = gql`
	query GetFolderName(
		$entityType: FoldersApiEntityType!
		$entityId: String!
		$folderId: String!
	) {
		folder(entityType: $entityType, entityId: $entityId, folderId: $folderId) {
			id
			name
		}
	}
`;

export const useFolderName = (folderId: string | undefined) => {
	const { entityId, entityType } = useDocumentsContext();
	const { data } = useQuery<Pick<Query, 'folder'>, QueryFolderArgs>(GET_FOLDER_NAME, {
		skip: !folderId,
		variables: {
			entityId,
			entityType,
			folderId: folderId!,
		},
	});

	return folderId ? data?.folder.name ?? '' : getRootFolderName(entityType);
};
